import create from 'zustand';

type UrlSet = {
  url: string;
  uri: string;
};

type Params = {
  urlSet: UrlSet[];
  setUrlSet: (urlSet: UrlSet[]) => void;
  replaceUrl: (html: string) => string;
  getExitUris: (html: string) => string[];
  clearUrlSet: () => void;
};

const htmlEncode = (str: string) => {
  let temp = '';
  if (str.length === 0) {
    return '';
  }

  temp = str.replace(/&/g, '&amp;');
  temp = temp.replace(/</g, '&lt;');
  temp = temp.replace(/>/g, '&gt;');
  temp = temp.replace(/\s/g, '&nbsp;');
  temp = temp.replace(/'/g, '&#39;');

  temp = temp.replace(/"/g, '&quot;');
  return temp;
};

const usePostImageSet = create<Params>((set, getState) => ({
  urlSet: [],
  setUrlSet: sets => {
    const encodeSets = sets.map(item => ({
      url: htmlEncode(item.url),
      uri: item.uri,
    }));
    set(state => ({
      ...state,
      urlSet: Array.from(new Set([...state.urlSet, ...encodeSets])),
    }));
  },
  replaceUrl: (html: string) => {
    const { urlSet } = getState();
    let _html = html;
    urlSet
      .filter(_set => html.includes(_set.url))
      .forEach(_set => {
        _html = _html.replace(
          _set.url,
          `https://p1-ma-forum-sign.byteimg.com/${_set.uri}`,
        );
      });
    return _html;
  },
  getExitUris: html => {
    const { urlSet } = getState();
    return urlSet.filter(_set => html.includes(_set.uri)).map(_set => _set.uri);
  },
  clearUrlSet: () => set(state => ({ ...state, urlSet: [] })),
}));

export default usePostImageSet;
